import * as yup from 'yup';
import { IPublicAgent, publicAgentSchema } from '../Agent/Agent';
import { CHAT_TYPE, ChatTypes } from '../ChatRoom/ChatRoom';
import { buyerDetailAfterMatchSchema, IBuyerDetailAfterMatch } from '../Buyer/Buyer';

export const MATCH_STATUSES = {
    MATCH_STATUS_WAITING_ACCEPT: 'MATCH_STATUS_WAITING_ACCEPT',
    MATCH_STATUS_CONNECTED: 'MATCH_STATUS_CONNECTED',
    MATCH_STATUS_EXPIRED: 'MATCH_STATUS_EXPIRED',
    MATCH_STATUS_DECLINED: 'MATCH_STATUS_DECLINED',
};
export type MatchStatus = (typeof MATCH_STATUSES)[keyof typeof MATCH_STATUSES];

export interface IMatch {
    id: number;
    company: number;
    agent: IPublicAgent;
    date_matched: string | null;
    meeting_date: string | null;
    message_from_brokerage: string;
    premium_offer: boolean;
    archived: boolean;
    archived_reason: string | null;
    status: MatchStatus;
    from_agent_user: {
        id: number;
        last_name: string;
        first_name: string;
        job: string;
        department: string;
        icon_image: string | null;
    };
    chat_room?: {
        id: number;
        chat_type: ChatTypes;
        unread: boolean;
    } | null;
    already_survey_answered?: boolean;
    created_at: string;
}

export interface IMatchForAgent {
    id: number;
    company: {
        id: number;
        name: string;
        icon_image: string;
        industry: string;
        area: string;
        prefecture: string;
        number_of_employees: string;
        revenue_scale: string;
        question: string | null;
        business_description: string;
    };
    buyer: IBuyerDetailAfterMatch;
    date_matched: string | null;
    meeting_date: string | null;
    message_from_brokerage: string;
    status: MatchStatus;
    chat_room?: {
        id: number;
        chat_type: ChatTypes | null;
    } | null;
    archived: boolean;
    archived_reason: string | null;
    already_survey_answered?: boolean;
    created_at: string;
}

export const matchSchema = yup.object({
    id: yup.number().required(),
    company: yup.number().required(),
    agent: publicAgentSchema.required(),
    date_matched: yup.string().nullable().defined(),
    meeting_date: yup.string().nullable().defined(),
    message_from_brokerage: yup.string().required(),
    premium_offer: yup.boolean().required(),
    archived: yup.boolean().required(),
    archived_reason: yup.string().nullable().defined(),
    status: yup.string().oneOf(Object.values(MATCH_STATUSES)).required(),
    from_agent_user: yup
        .object({
            id: yup.number().required(),
            last_name: yup.string().required(),
            first_name: yup.string().required(),
            job: yup.string().required(),
            department: yup.string().required(),
            icon_image: yup.string().nullable().defined(),
        })
        .required(),
    chat_room: yup
        .object({
            id: yup.number().required(),
            chat_type: yup.string().oneOf(Object.values(CHAT_TYPE)).defined(),
            unread: yup.boolean().required(),
        })
        .nullable(),
    created_at: yup.string().required(),
});

export const matchSchemaForAgent = yup.object({
    id: yup.number().required(),
    company: yup
        .object({
            id: yup.number().required(),
            name: yup.string().required(),
            icon_image: yup.string().required(),
            industry: yup.string().required(),
            area: yup.string().required(),
            prefecture: yup.string().required(),
            number_of_employees: yup.string().required(),
            revenue_scale: yup.string().required(),
            question: yup.string().defined(),
            business_description: yup.string().required(),
            profit_level: yup.string().required(),
            net_assets_level: yup.string().required(),
        })
        .required(),
    buyer: buyerDetailAfterMatchSchema.required(),
    date_matched: yup.string().nullable().defined(),
    meeting_date: yup.string().nullable().defined(),
    message_from_brokerage: yup.string().required(),
    status: yup.string().oneOf(Object.values(MATCH_STATUSES)).required(),
    chat_room: yup
        .object({
            id: yup.number().required(),
            chat_type: yup.string().oneOf(Object.values(CHAT_TYPE)).defined(),
            unread: yup.boolean().required(),
        })
        .nullable(),
    archived: yup.boolean().required(),
    archived_reason: yup.string().nullable().defined(),
    created_at: yup.string().required(),
});
